import { dataExamResult } from './dataExamResult';

export const dataExamResults = {
  type: 'array',
  items: dataExamResult,
};
